import { ApiBaseService, ApiV2Service } from './api.base.service';
import {
  UploadImageUrlResponse,
  SuccessResponse,
  GatewayType,
} from '@/types';

export class AdminGatewayTypeService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async getSystemGatewayType(gatewayTypeId: number): Promise<GatewayType> {
    return this.api.get(`admin/gatewayTypes/${gatewayTypeId}`);
  }

  public async getSystemGatewayTypes(): Promise<GatewayType[]> {
    return this.api.get(`admin/gatewayTypes`);
  }

  public async addSystemGatewayType(body: { name?: string; keep_alive?: number; has_cellular_backhaul: boolean }): Promise<GatewayType> {
    return this.api.post(`admin/gatewayTypes`, body);
  }

  public async updateSystemGatewayType(gatewayTypeId: number, body: { name?: string; keep_alive?: number; has_cellular_backhaul: boolean }): Promise<GatewayType> {
    return this.api.put(`admin/gatewayTypes/${gatewayTypeId}`, body);
  }

  public async uploadGatewayLogo(id: number, file: Blob): Promise<any> {
    const urlResp = await this.api.get<UploadImageUrlResponse>(`admin/gatewayTypes/${id}/logo-upload-url`);
    const data = urlResp.urlInfo;
    const formData = new FormData();
    // formData.append('Content-Type', file.type);
    Object.entries(data.fields).forEach(([k, v]) => {
      formData.append(k, (v as string));
    });
    formData.append('file', file);
    return this.api.postFormExt(data.url, formData);
  }

  public async removeGatewayLogo(id: number): Promise<SuccessResponse> {
    return this.api.delete(`admin/gatewayTypes/${id}/logo`);
  }

}

export default new AdminGatewayTypeService();
